import { SearchEntityVersionFragment } from 'types/graphql'

import { SelectValue } from 'src/components/Selects/EntityVersionSearch/types'

export const selectValueEquals = (a: SelectValue, b: SelectValue) => {
  return (
    (typeof a === 'string' && typeof b === 'string' && a === b) ||
    (typeof a !== 'string' && typeof b !== 'string' && a.id === b.id)
  )
}

export const isSelectValueSearchEntityVersionFragment = (
  value: SelectValue
): value is SearchEntityVersionFragment => {
  return typeof value !== 'string'
}
